import FormValidator from './formValidation';

export default {
  init(divId, formId, config, onChange, beforeNext) {
    const validatorResult = FormValidator.init(formId, config);
    const form = validatorResult[0];
    const error = validatorResult[1];
    const success = validatorResult[2];
    const validator = validatorResult[3];

    const wizard = new mWizard(divId.substring(1), { startStep: 1 });

    // == Validation before going to next page
    if (beforeNext) {
      wizard.on('beforeNext', beforeNext);
    } else {
      wizard.on('beforeNext', wizardObj => {
        if (validator.form() !== true) {
          wizardObj.stop();
        }
      });
    }

    // == Change event
    if (onChange) {
      wizard.on('change', onChange);
    } else {
      wizard.on('change', () => {
        window.scrollTo(error, 0);
      });
    }

    return { form, error, success, wizard, validator };
  },

  config() {
    FormValidator.config();
  },
};
